import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cfp-report-footer',
  styleUrls: ['report-footer.scss'],
  templateUrl: 'report-footer.html',
  imports: [TranslateModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportFooter {
  public readonly showPoweredBy = input<boolean>(true);
  /** When true (default), footer is print-only. When false, visible on screen (e.g. embedded in a page card). */
  public readonly printOnly = input<boolean>(true);
}
